module.exports = __webpack_public_path__ + "static/bank-a36b89ab57b59bd4377cc5a64882baae.jpg";